import { BehaviorSubject } from 'rxjs';
import { INotificationItem } from 'interfaces';

export const NotificationsService = new BehaviorSubject<INotificationItem[]>([]);

export const sendNotifications = (notifications: INotificationItem[]) => {
  NotificationsService.next(notifications);
};
